var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarPatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.482 0a7.977 7.977 0 1 1 0 15.954A7.977 7.977 0 0 1 8.482 0zm1.813 16.454L12.343 20l.827-3.902 3.793 1.234-2.048-3.547a8.659 8.659 0 0 1-4.62 2.669zm-3.627 0a8.658 8.658 0 0 1-4.62-2.67L0 17.333l3.793-1.234L4.62 20l2.048-3.546zm1.814-15.26a6.784 6.784 0 1 0 0 13.567 6.784 6.784 0 0 0 0-13.567zm0 .69a6.094 6.094 0 1 0 0 12.187 6.094 6.094 0 0 0 0-12.188z",
    fill: "#EFDF00",
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 12 4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.124.383 2.27 2.116.36 2.394a.419.419 0 0 0-.232.715L1.51 4.456 1.183 6.36a.418.418 0 0 0 .607.44l1.71-.898 1.71.899a.419.419 0 0 0 .607-.441L5.49 4.456 6.873 3.11a.419.419 0 0 0-.232-.715L4.73 2.116 3.876.383a.42.42 0 0 0-.752 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarPatch);
export default __webpack_public_path__ + "static/media/star-patch.ba124052ba3a2ddc2215aba167c3716c.svg";
export { ForwardRef as ReactComponent };